import { useState, useEffect } from "react";

export function useDropdownData(
  fetchFunction,
  fetchArgs = [],
  dependencies = []
) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await fetchFunction(...fetchArgs);
        console.log("result fetched:", result);

        if (Array.isArray(result)) {
          console.log("setting the data");
          setData(result);
        } else {
          console.log("No data found");
          setError("No data found");
        }
      } catch (err) {
        console.error(err);
        setError("Fetch failed");
      } finally {
        setLoading(false);
      }
    };

    // Only fetch if all arguments are truthy (e.g., countryId, token)
    if (fetchArgs.every((arg) => arg)) {
      fetchData();
    }
  }, dependencies);

  return { data, loading, error };
}
